import React from 'react';
import { useDropzone } from 'react-dropzone';

const UploadDropzone = ({ accept, onDrop, maxSize, label }) => {
  const { getRootProps, getInputProps } = useDropzone({ onDrop, maxSize, accept });

  return (
    <section>
      <div {...getRootProps({ className: 'dropzone' })}>
        <input {...getInputProps()} accept={accept} />
        <p>{label || "Drag 'n' drop some files here, or click to select files"}</p>
      </div>
    </section>
  );
};

export default React.memo(UploadDropzone);
